let loginAsUserIdForSuperAdmin: string | undefined;

export const getLoginAsUserIdForSuperAdmin = (): string | undefined => loginAsUserIdForSuperAdmin;

export const setLoginAsUserIdForSuperAdmin = (id: string | null | undefined) => {
    loginAsUserIdForSuperAdmin = id ?? undefined;
};
